<template>

  <div>
     <KTCodePreview v-bind:title="'In phiếu'"
      > <template v-slot:toolbar
        > <b-button
          variant="primary"
          size="sm"
          @click="printData"
          style="width: max-content"
          > <i class="fas fa-print"></i> In phiếu </b-button
        > </template
      > <template v-slot:preview
        >
        <div id="printMe">
           <b-row
            style="display: block"
            class="mb-10"
            >
            <div class="text-center">

              <h5>Phiếu cho mượn</h5>

            </div>
             </b-row
          > <b-row
            > <b-col md="8"
              >
              <p> <span class="custom-lable-text">Mã phiếu</span> : {{ stockSlip.code }} </p>
               </b-col
            > <b-col md="4"
              >
              <p> <span class="custom-lable-text">Cửa hàng</span> : {{ stockSlip.storeName }} </p>
               </b-col
            > </b-row
          > <b-row
            > <b-col md="8"
              >
              <p> <span class="custom-lable-text">Ngày</span> : {{ stockSlip.createdAt }} </p>
               </b-col
            > <b-col md="4"
              >
              <p> <span class="custom-lable-text">Địa chỉ</span> : {{ stockSlip.storeAddress }} </p>
               </b-col
            > </b-row
          > <b-row
            > <b-col md="8"
              >
              <p>
                 <span class="custom-lable-text">Đối tượng</span> : {{
                  stockSlip.recipientName || '-'
                }}
              </p>
               </b-col
            > <b-col md="4"
              >
              <p> <span class="custom-lable-text">Người lập</span> : {{ stockSlip.createdBy }} </p>
               </b-col
            > </b-row
          > <b-row
            > <b-col md="8"
              >
              <p>
                 <span class="custom-lable-text">Lý do</span> : {{ stockSlip.reasonName || '-' }}
              </p>
               </b-col
            > <b-col md="4"
              >
              <p>
                 <span class="custom-lable-text">Ngày hẹn trả</span> : {{
                  stockSlip.expectedReturnAt || '-'
                }}
              </p>
               </b-col
            > </b-row
          > <b-row
            > <b-col md="8"
              >
              <p>
                 <span class="custom-lable-text">Ghi chú</span> : {{ stockSlip.description || '-' }}

              </p>
               </b-col
            > </b-row
          > <b-table
            :items="listItem"
            :fields="fields"
            :bordered="true"
            :hover="true"
            > <template slot="bottom-row"
              >
              <td
                v-bind:colspan="5"
                class="text-right font-weight-bolder"
                style="font-weight: 600; color: #181c32"
              >
                 <span>Tổng:</span>
              </td>

              <td class="text-right font-weight-bolder">
                 <span>{{ formatMoney(sumQuantity) }}</span
                >
              </td>
               </template
            > </b-table
          > <b-row
            > <b-col class="text-center"
              >
              <p class="mb-0"> <span class="custom-lable-text">Người lập phiếu</span> </p>

              <p>(Ký, họ tên)</p>
               </b-col
            > <b-col
              >
              <p class="mb-0"> <span class="custom-lable-text">Người giao hàng</span> </p>

              <p>(Ký, họ tên)</p>
               </b-col
            > <b-col
              >
              <p class="mb-0"> <span class="custom-lable-text">Người nhận hàng</span> </p>

              <p>(Ký, họ tên)</p>
               </b-col
            > <b-col
              >
              <p class="mb-0"> <span class="custom-lable-text">Thủ kho</span> </p>

              <p>(Ký, họ tên)</p>
               </b-col
            > <b-col
              >
              <p class="mb-0"> <span class="custom-lable-text">Giám đốc</span> </p>

              <p>(Ký, họ tên)</p>
               </b-col
            > </b-row
          >
        </div>
         </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import ApiService from '@/core/services/api.service'
  import moment from 'moment'
  import _ from 'lodash'
  import { printData } from '@/utils/common'
  import { convertToDateSlash, DATE_FORMAT } from '@/utils/date'

  export default {
    data() {
      return {
        fields: [
          {
            key: 'count',
            label: 'STT',
            thStyle: {
              textAlign: 'center',
              fontWeight: 600,
              color: '#181c32',
              width: '4%',
            },
            tdClass: 'text-center',
          },
          {
            key: 'barCode',
            label: 'Mã vạch',
            thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          },
          {
            key: 'productCode',
            label: 'Mã sản phẩm',
            thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          },
          {
            key: 'productName',
            label: 'Tên sản phẩm',
            thStyle: { fontWeight: 600, color: '#181c32', width: '17%' },
          },
          {
            key: 'imeiCode',
            label: 'IMEI',
            thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          },
          {
            key: 'quantity',
            label: 'SL',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
            tdClass: 'text-right',
            formatter: (value) => {
              return this.formatMoney(value)
            },
          },
        ],
        listItem: [],
        stockSlip: {
          code: '',
          storeName: '',
          createdAt: '',
          storeAddress: '',
          recipientName: '',
          recipientTypeName: '',
          reasonName: '',
          expectedReturnAt: '',
          createdBy: '',
          description: '',
        },
        sumQuantity: 0,
      }
    },
    components: {
      KTCodePreview,
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: 'In phiếu cho mượn' }])
      this.getStockSlipById()
    },
    methods: {
      printData() {
        printData()
      },
      formatMoney(number) {
        if (!number) return 0
        return new Intl.NumberFormat('vn-VN').format(number)
      },
      getStockSlipById: async function () {
        const stockSlipId = this.$route.query.id
        if (!stockSlipId) return

        await ApiService.get(`v1/stock-status-transfer/lending-stock-slips/${stockSlipId}`)
          .then((data) => {
            const stockSlipData = data.data.data
            this.listItem = (stockSlipData.details || []).map((element, index) => ({
              count: index + 1,
              barCode: element.productBarCode || element.barCode || '',
              productCode: element.productCode || '',
              productName: element.productName || '',
              imeiCode: element.productImei || element.imeiCode || '',
              quantity: element.quantity || 0,
            }))

            const expectedReturnRaw = stockSlipData.expectedReturnAt || stockSlipData.lendingAt
            this.stockSlip = {
              code: stockSlipData.code || '',
              storeName: stockSlipData.storeName || '',
              createdAt: stockSlipData.createdAt
                ? moment(stockSlipData.createdAt).format('HH:mm DD/MM/YYYY')
                : '',
              storeAddress: stockSlipData.storeAddress || '',
              recipientName: stockSlipData.recipientName || '',
              recipientTypeName: stockSlipData.recipientTypeName || '',
              reasonName: stockSlipData.reasonName || '',
              expectedReturnAt: expectedReturnRaw
                ? convertToDateSlash(expectedReturnRaw, DATE_FORMAT)
                : '',
              createdBy: stockSlipData.createdBy || '',
              description: stockSlipData.description || '',
            }

            this.sumQuantity = _.sumBy(this.listItem, 'quantity')
          })
          .catch(() => {
            this.listItem = []
          })
      },
    },
  }
</script>

<style scoped>
  .custom-lable-text {
  font-size: 13px;
  font-weight: 500 !important;
}
</style>

<style>
  .table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>

